<template>
  <div ref="scrollWrapper" class="vue-scrollbar__wrapper">
    <slot></slot>
  </div>
  </div>
</template>
<script>
  export default {
  data() {
    return {

    }
  },
  mounted() {
    this.scrollDom = this.$refs.scrollWrapper;
  },
  methods: {
    scroll(e) {
      this.$emit('onScroll',e);
    },
    getClientHeight() {
      return this.scrollDom.clientHeight
    },
    getScrollHeight() {
      return this.scrollDom.scrollHeight
    },
    getScrollTop() {
      return this.scrollDom.scrollTop
    },
    setScrollTop(y) {
      if (typeof y === 'number' && this.scrollDom) {
        this.scrollDom.scrollTop = y
      }
    },
    getStep(start, end, callback, t, rate) {
      let diff = end - start
      if (t === 0 || diff === 0) {
        callback && callback(end)
        return
      }
      t = t || 300
      rate = rate || 30
      let count = t / rate
      let step = diff / count
      let i = 0
      let timer = setInterval(() => {
        if (i < count - 1) {
          start += step
          callback && callback(start, timer)
          i++
        } else {
          callback && callback(end, timer)
          clearInterval(timer)
        }
      }, rate)
    },
    scrollToY(y, noTransition = false) {
      let start = this.getScrollTop()
      let end = y
      if (end > 0) {
        let maxY = this.getScrollHeight() - this.getClientHeight()
        if (end > maxY) end = maxY // 不可超过最大值
      } else {
        end = 0
      }
      if (!noTransition) {
        this.getStep(start, end, (step) => {
          this.setScrollTop(step)
          if (step === end) {
            this.isScrollTo = false
          }
        }, 300)
      } else {
        this.setScrollTop(y);
      }
    },
  },
  beforeDestroy() {
    // Remove Event
    window.removeEventListener('resize', this.calculateSize)
  }

}
</script>
<style type="text/css" scoped>
.vue-scrollbar__wrapper {
  margin: 0 auto;
  overflow-y: auto !important;
}
</style>